import AssetLog, { IAssetLog, IAssetLogApiModel } from '@models/AssetLog.model';
import { api } from '@services';

interface IRequest {
  equipmentId: string;
}

const getAssetHistory = async ({
  equipmentId,
}: IRequest): Promise<IAssetLog[]> => {
  const { data: assetHistory } = await api.get<IAssetLogApiModel[]>(
    `/equipments/${equipmentId}/asset/history`,
  );

  return AssetLog.arrayFromApiModel(assetHistory);
};

export { getAssetHistory };
